export const fileDrawerStyles = { top: "104px", width: "420px", transform: "initial" }
